import { Layout } from "antd";
import "./style.css";
import NavBar from "../navbar";

interface IProps {
  children: React.ReactNode;
}

const LayoutContent: React.FC<IProps> = ({ children }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        overflowY: "hidden",
        height: "100vh",
      }}
    >
      <NavBar />
      <Layout.Content className="content">{children}</Layout.Content>
    </div>
  );
};

export default LayoutContent;
